import translation from './reducers'

export { addTranslations } from './actions'

export default translation
